export const diagnosis = {
  path: "/diagnosis",
  name: "diagnosis",
  hidden: false,
  component: () => import("@/components/diagnosis/index"),
  meta: {
    title: "Form Diagnosis",
    icon: "",
    roles: [""]
  }
};
export default diagnosis;



// WEBPACK FOOTER //
// ./src/router/modules/diagnosis.js